import TranslatableText from "@components/translations/TranslatableText";

const OFFLINE_APP_BASE_URL =
  "https://storage.googleapis.com/fao-exact-fao-exact-frontend-static";
const OFFLINE_APP_URL = `${OFFLINE_APP_BASE_URL}/EX-ACT%20v1%20Setup%201.1.0.exe`;
const OFFLINE_APP_GUIDE_URL = `${OFFLINE_APP_BASE_URL}/How_To_-_Install_The_EX-ACT_Offline_Tool.pdf`;
const OFFLINE_APP_LAST_UPDATE = "2026-10-09";

const EXCEL_SUPPORT_EMAIL = "ex-act@fao.org";

const excelNoteEmailLink = (
  <a href={`mailto:${EXCEL_SUPPORT_EMAIL}`} className="text-quat-de" />
);

const guideLink = (
  <a
    href={OFFLINE_APP_GUIDE_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="text-quat-de"
  />
);

const DownloadOfflineApp = () => (
  <section className="px-2">
    <div style={{ borderTop: "0.5px solid var(--gray)" }} className="py-2">
      <h3 className="welcome-user-header ff-medium-ext">
        <TranslatableText translationKey="main.download_offline_app" />
      </h3>
      <p className="pt-1 fs-13 mb-0">
        <a href={OFFLINE_APP_URL} download className="text-quat-de">
          Environmental eXternalities ACcounting Tool 1.1.0 [Windows]
        </a>
      </p>
      <ul className="pt-1 ps-3 fs-12 ff-light mb-0">
        <li>
          <TranslatableText
            translationKey="main.download_offline_app_install_guide"
            paramsComponents={[guideLink]}
          />
        </li>
        <li>
          <TranslatableText translationKey="main.download_offline_app_windows_only" />
        </li>
        <li>
          <TranslatableText
            translationKey="main.download_offline_app_last_update"
            translationParams={{ date: OFFLINE_APP_LAST_UPDATE }}
          />
        </li>
      </ul>
      <p className="pt-1 fs-12 ff-light mb-0">
        <TranslatableText
          translationKey="main.download_offline_app_excel_note"
          translationParams={{ email: EXCEL_SUPPORT_EMAIL }}
          paramsComponents={[excelNoteEmailLink]}
        />
      </p>
    </div>
  </section>
);

export default DownloadOfflineApp;
